import { twMerge } from 'tailwind-merge'

type CardHeaderProps = {
  className?: string
  children: React.ReactNode
}

export function CardHeader({ className, children }: CardHeaderProps) {
  return (
    <div className={twMerge(
      'px-4 pt-3 pb-2 font-semibold antialiased flex justify-between',
      className
    )}>
      {children}
    </div>
  )
}
